const SWEEP_PROGRESS = 0.86;
const START_ANGLE_RAD = -Math.PI / 2;

export default function RolesIcon({ className }: { className?: string }) {
  const cx = 10;
  const cy = 10;
  const radius = 6;
  const sweepAngle = SWEEP_PROGRESS * Math.PI * 2;
  const endAngle = START_ANGLE_RAD + sweepAngle;
  const startX = cx + radius * Math.cos(START_ANGLE_RAD);
  const startY = cy + radius * Math.sin(START_ANGLE_RAD);
  const endX = cx + radius * Math.cos(endAngle);
  const endY = cy + radius * Math.sin(endAngle);
  const largeArcFlag = sweepAngle > Math.PI ? 1 : 0;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={`M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}`}
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
